import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent implements OnInit{
  title = 'Client Utilisation';

  readonly #router = inject(Router)
  readonly #iconSetService = inject(IconSetService)
  constructor(){
    this.#iconSetService.icons = { ...iconSubset };
  }
  ngOnInit(): void{

  }
}
